<style>
.mint-swipe {
    overflow: hidden;
    position: relative;
    height: 100%;
}

.mint-swipe-items-wrap {
    position: relative;
    overflow: hidden;
    height: 100%;
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.mint-swipe-items-wrap>div {
    position: absolute;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    width: 100%;
    height: 100%;
    display: none;
    background: #f0f0f0;
}

.mint-swipe-items-wrap>div:first-child {
    display: block;
    -webkit-transform: none;
    transform: none;
}

.mint-swipe-items-wrap>div.is-active {
    display: block;
    -webkit-transform: none;
    transform: none;
}

.mint-swipe-indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

.mint-swipe-indicator {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
    margin: 0 3px;
}

.mint-swipe-indicator.is-active {
    background: #fff;
}

.mint-swipe-picIcon {
    position: absolute;
    top: 9px;
    right: 10px;
    display: inline-block;
    height: 23px;
    color: #fff;
}

.mint-swipe-picIcon i {
    display: none;
}
.img-num {
    line-height: 23px;
    font-size: 12px;
    letter-spacing: 2px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.7);
}
.img-num .active-img {
    font-size: 15px;
    font-weight: 500;
    color: #fff;
}
</style>

<template>
<div class="mint-swipe">
    <div class="mint-swipe-items-wrap" ref="wrap">
        <slot :class="{'is-active': !isMounted}"></slot>
    </div>
    <div class="mint-swipe-indicators" v-show="showIndicators">
        <div class="mint-swipe-indicator" v-for="(page, $index) in pages" :class="{ 'is-active': $index === index }" :key="$index"></div>
    </div>
    <div class="mint-swipe-picIcon" v-show="showPicIcon" v-if="pages.length>1">
        <span class="img-num"><i class="icon-image"></i><span class="active-img">{{index+1}}</span>/{{pages.length}}</span>
    </div>
</div>
</template>

<script>
  var addClass = function (el, cls) {
    if (!el) return;
    var curClass = el.className;
    var classes = (cls || '').split(' ');

    for (var i = 0, j = classes.length; i < j; i++) {
      var clsName = classes[i];
      if (!clsName) continue;

      if (el.classList) {
        el.classList.add(clsName);
      } else {
        if (!hasClass(el, clsName)) {
          curClass += ' ' + clsName;
        }
      }
    }
    if (!el.classList) {
      el.className = curClass;
    }
  };

  var removeClass = function (el, cls) {
    if (!el || !cls) return;
    var classes = cls.split(' ');
    var curClass = ' ' + el.className + ' ';

    for (var i = 0, j = classes.length; i < j; i++) {
      var clsName = classes[i];
      if (!clsName) continue;

      if (el.classList) {
        el.classList.remove(clsName);
      } else {
        if (hasClass(el, clsName)) {
          curClass = curClass.replace(' ' + clsName + ' ', ' ');
        }
      }
    }
    if (!el.classList) {
      el.className = trim(curClass);
    }
  };

  var bindEvent;
  var unbindEvent;
  var bindOnce;

export default {
    name: 'mt-swipe',

    created() {
        this.dragState = {};
    },

    data() {
        return {
            ready: false,
            dragging: false,
            userScrolling: false,
            animating: false,
            index: 0,
            pages: [],
            timer: null,
            reInitTimer: null,
            noDrag: false,
            isMounted: false
        };
    },

    props: {
        speed: {
            type: Number,
            default: 300
        },

        auto: {
            type: Number,
            default: 3000
        },

        continuous: {
            type: Boolean,
            default: true
        },

        showIndicators: {
            type: Boolean,
            default: true
        },

        noDragWhenSingle: {
            type: Boolean,
            default: true
        },

        prevent: {
            type: Boolean,
            default: false
        },

        showPicIcon: {
            type: Boolean,
            default: false
        },

        startPage: {
            type: Number,
            default: 0
        },
        vertical: {
            type: Boolean,
            default: false
        },
        enableDrag: {
            type: Boolean,
            default: true
        }

    },

    methods: {
        swipeItemCreated() {
            if (!this.ready) return;

            clearTimeout(this.reInitTimer);
            this.reInitTimer = setTimeout(() => {
                this.reInitPages();
            }, 100);
        },

        swipeItemDestroyed() {
            if (!this.ready) return;

            clearTimeout(this.reInitTimer);
            this.reInitTimer = setTimeout(() => {
                this.reInitPages();
            }, 100);
        },

        translate(element, offset, speed, callback) {
            if (speed) {
                this.animating = true;
                element.style.webkitTransition = '-webkit-transform ' + speed + 'ms ease-in-out';
                setTimeout(() => {
                    if (this.vertical) {
                        element.style.webkitTransform = `translate3d(0, ${offset}px, 0)`;
                    } else {
                        element.style.webkitTransform = `translate3d(${offset}px, 0, 0)`;
                    }
                }, 50);

                var called = false;

                var transitionEndCallback = () => {
                    if (called) return;
                    called = true;
                    this.animating = false;
                    element.style.webkitTransition = '';
                    element.style.webkitTransform = '';
                    if (callback) {
                        callback.apply(this, arguments);
                    }
                };

                bindOnce(element, 'webkitTransitionEnd', transitionEndCallback);
                setTimeout(transitionEndCallback, speed + 100); // webkitTransitionEnd maybe not fire on lower version android.
            } else {
                element.style.webkitTransition = '';
                if (this.vertical) {
                        element.style.webkitTransform = `translate3d(0, ${offset}px, 0)`;
                    } else {
                        element.style.webkitTransform = `translate3d(${offset}px, 0, 0)`;
                    }
            }
        },

        reInitPages() {
            var children = this.$children;
            this.noDrag = children.length === 1 && this.noDragWhenSingle;

            var pages = [];
            var start;
            this.index = this.startPage || 0;
            start = this.index;

            children.forEach(function(child, index) {
                pages.push(child.$el);

                removeClass(child.$el, 'is-active');

                if (index === start) {
                    addClass(child.$el, 'is-active');
                }
            });

            this.pages = pages;
        },

        doAnimate(towards, options) {
            if (this.$children.length === 0) return;
            if (!options && this.$children.length < 2) return;

            var prevPage, nextPage, currentPage, pageWidth, pageHeight, offsetLeft, offsetTop, pageNum;
            var speed = this.speed || 300;
            var index = this.index;
            var pages = this.pages;
            var pageCount = pages.length;

            if (!options) {
                pageWidth = this.$el.clientWidth;
                pageHeight = this.$el.clientHeight;
                currentPage = pages[index];
                prevPage = pages[index - 1];
                nextPage = pages[index + 1];
                pageNum = this.vertical ? pageHeight : pageWidth;
                if (this.continuous && pages.length > 1) {
                    if (!prevPage) {
                        prevPage = pages[pages.length - 1];
                    }
                    if (!nextPage) {
                        nextPage = pages[0];
                    }
                }
                if (prevPage) {
                    prevPage.style.display = 'block';
                    this.translate(prevPage, -pageNum);
                }
                if (nextPage) {
                    nextPage.style.display = 'block';
                    this.translate(nextPage, pageNum);
                }
            } else {
                prevPage = options.prevPage;
                currentPage = options.currentPage;
                nextPage = options.nextPage;
                pageWidth = options.pageWidth;
                pageHeight = options.pageHeight;
                offsetLeft = options.offsetLeft;
                pageNum = this.vertical ? pageHeight : pageWidth;
            }

            var newIndex;

            var oldPage = this.$children[index].$el;

            if (towards === 'prev') {
                if (index > 0) {
                    newIndex = index - 1;
                }
                if (this.continuous && index === 0) {
                    newIndex = pageCount - 1;
                }
            } else if (towards === 'next') {
                if (index < pageCount - 1) {
                    newIndex = index + 1;
                }
                if (this.continuous && index === pageCount - 1) {
                    newIndex = 0;
                }
            }

            var callback = () => {
                if (newIndex !== undefined) {
                    var newPage = this.$children[newIndex].$el;
                    removeClass(oldPage, 'is-active');
                    addClass(newPage, 'is-active');

                    this.index = newIndex;
                }

                if (prevPage) {
                    prevPage.style.display = '';
                }

                if (nextPage) {
                    nextPage.style.display = '';
                }
            };

            setTimeout(() => {
                if (towards === 'next') {
                    this.translate(currentPage, -pageNum, speed, callback);
                    if (nextPage) {
                        this.translate(nextPage, 0, speed);
                    }
                } else if (towards === 'prev') {
                    this.translate(currentPage, pageNum, speed, callback);
                    if (prevPage) {
                        this.translate(prevPage, 0, speed);
                    }
                } else {
                    this.translate(currentPage, 0, speed, callback);
                    if (typeof offsetLeft !== 'undefined') {
                        if (prevPage && offsetLeft > 0) {
                            this.translate(prevPage, pageNum * -1, speed);
                        }
                        if (nextPage && offsetLeft < 0) {
                            this.translate(nextPage, pageNum, speed);
                        }
                    } else {
                        if (prevPage) {
                            this.translate(prevPage, pageNum * -1, speed);
                        }
                        if (nextPage) {
                            this.translate(nextPage, pageNum, speed);
                        }
                    }
                }
            }, 10);
        },

        next() {
            this.doAnimate('next');
        },

        prev() {
            this.doAnimate('prev');
        },

        doOnTouchStart(event) {
            if (this.noDrag || !this.enableDrag) return;

            var element = this.$el;
            var dragState = this.dragState;
            var touch = event.touches[0];

            dragState.startTime = new Date();
            dragState.startLeft = touch.pageX;
            dragState.startTop = touch.pageY;
            dragState.startTopAbsolute = touch.clientY;

            dragState.pageWidth = element.offsetWidth;
            dragState.pageHeight = element.offsetHeight;

            var prevPage = this.$children[this.index - 1];
            var dragPage = this.$children[this.index];
            var nextPage = this.$children[this.index + 1];

            if (this.continuous && this.pages.length > 1) {
                if (!prevPage) {
                    prevPage = this.$children[this.$children.length - 1];
                }
                if (!nextPage) {
                    nextPage = this.$children[0];
                }
            }

            dragState.prevPage = prevPage ? prevPage.$el : null;
            dragState.dragPage = dragPage ? dragPage.$el : null;
            dragState.nextPage = nextPage ? nextPage.$el : null;

            if (dragState.prevPage) {
                dragState.prevPage.style.display = 'block';
            }

            if (dragState.nextPage) {
                dragState.nextPage.style.display = 'block';
            }
        },

        doOnTouchMove(event) {
            if (this.noDrag || !this.enableDrag) return;

            var dragState = this.dragState;
            var touch = event.touches[0];

            dragState.currentLeft = touch.pageX;
            dragState.currentTop = touch.pageY;
            dragState.currentTopAbsolute = touch.clientY;

            var offsetLeft = dragState.currentLeft - dragState.startLeft;
            var offsetTop = dragState.currentTopAbsolute - dragState.startTopAbsolute;

            var distanceX = Math.abs(offsetLeft);
            var distanceY = Math.abs(offsetTop);
            if (distanceX < 5 || (distanceX >= 5 && distanceY >= 1.73 * distanceX)) {
                this.userScrolling = true;
                return;
            } else {
                this.userScrolling = false;
                event.preventDefault();
            }
            offsetLeft = Math.min(Math.max(-dragState.pageWidth + 1, offsetLeft), dragState.pageWidth - 1);

            var towards = offsetLeft < 0 ? 'next' : 'prev';

            if (dragState.prevPage && towards === 'prev') {
                this.translate(dragState.prevPage, offsetLeft - dragState.pageWidth);
            }
            this.translate(dragState.dragPage, offsetLeft);
            if (dragState.nextPage && towards === 'next') {
                this.translate(dragState.nextPage, offsetLeft + dragState.pageWidth);
            }
        },

        doOnTouchEnd() {
            if (this.noDrag || !this.enableDrag) return;

            var dragState = this.dragState;

            var dragDuration = new Date() - dragState.startTime;
            var towards = null;

            var offsetLeft = dragState.currentLeft - dragState.startLeft;
            var offsetTop = dragState.currentTop - dragState.startTop;
            var pageWidth = dragState.pageWidth;
            var pageHeight = dragState.pageHeight;
            var index = this.index;
            var pageCount = this.pages.length;

            if (dragDuration < 300) {
                let fireTap = Math.abs(offsetLeft) < 5 && Math.abs(offsetTop) < 5;
                if (isNaN(offsetLeft) || isNaN(offsetTop)) {
                    fireTap = true;
                }
                if (fireTap) {
                    this.$children[this.index].$emit('tap');
                }
            }

            if (dragDuration < 300 && dragState.currentLeft === undefined) return;

            if (dragDuration < 300 || Math.abs(offsetLeft) > pageWidth / 2) {
                towards = offsetLeft < 0 ? 'next' : 'prev';
            }

            if (!this.continuous) {
                if ((index === 0 && towards === 'prev') || (index === pageCount - 1 && towards === 'next')) {
                    towards = null;
                }
            }

            if (this.$children.length < 2) {
                towards = null;
            }

            this.doAnimate(towards, {
                offsetLeft: offsetLeft,
                pageWidth: dragState.pageWidth,
                pageHeight: dragState.pageHeight,
                prevPage: dragState.prevPage,
                currentPage: dragState.dragPage,
                nextPage: dragState.nextPage
            });

            this.dragState = {};
        }
    },

    destroyed() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.reInitTimer) {
            clearTimeout(this.reInitTimer);
            this.reInitTimer = null;
        }
    },

    mounted() {
        bindEvent = (function() {
            if(document.addEventListener) {
            return function(element, event, handler) {
                if (element && event && handler) {
                element.addEventListener(event, handler, false);
                }
            };
            } else {
            return function(element, event, handler) {
                if (element && event && handler) {
                element.attachEvent('on' + event, handler);
                }
            };
            }
        })();

        unbindEvent = (function() {
            if(document.removeEventListener) {
            return function(element, event, handler) {
                if (element && event) {
                element.removeEventListener(event, handler, false);
                }
            };
            } else {
            return function(element, event, handler) {
                if (element && event) {
                element.detachEvent('on' + event, handler);
                }
            };
            }
        })();

        bindOnce = function(el, event, fn) {
            var listener = function() {
            if (fn) {
                fn.apply(this, arguments);
            }
            unbindEvent(el, event, listener);
            };
            bindEvent(el, event, listener);
        };
      
        this.ready = true;

        if (this.auto > 0) {
            this.timer = setInterval(() => {
                if (!this.dragging && !this.animating) {
                    this.next();
                }
            }, this.auto);
        }

        this.isMounted = true;

        this.reInitPages();

        var element = this.$el;

        element.addEventListener('touchstart', (event) => {
            if (this.prevent) {
                event.preventDefault();
            }
            if (this.animating) return;
            this.dragging = true;
            this.userScrolling = false;
            this.doOnTouchStart(event);
        });

        element.addEventListener('touchmove', (event) => {
            if (!this.dragging) return;
            this.doOnTouchMove(event);
        });

        element.addEventListener('touchend', (event) => {
            if (this.userScrolling) {
                this.dragging = false;
                this.dragState = {};
                return;
            }
            if (!this.dragging) return;
            this.doOnTouchEnd(event);
            this.dragging = false;
        });
    },
    watch: {
        startPage: function() {
            this.reInitPages();
        },
        index: function() {
            this.$emit('afterSlide', this.index);
        }
    }
};
</script>




// WEBPACK FOOTER //
// swipe.vue